import { romeApi } from "framework";
import { modalService } from "../../framework/utils/modal-service";
import store from "../../store";
import EnrollmentValidationErrors from "./EnrollmentValidationErrors";

class UploadEnrollmentsService {
    constructor(){
        this.$store = store;
    }
    
    reviewSuccessMessage = 'The enrollment file has been successfully uploaded.';

    async checkIfFileExists(employerId, actionItemId) {
        return await romeApi.get(`employer/${employerId}/enrollment/exists/${actionItemId}`);              
    }

    async checkIfFileHadErrors(employerId, actionItemId) {
        return await romeApi.get(`employer/${employerId}/enrollment/errors/${actionItemId}`);              
    }

    async onSpreadsheetSelect(selectedFile, employerId, actionItemId) {

        if(!selectedFile) return;
        
        let formData = new FormData();
        formData.append('file', selectedFile);

        let result = await romeApi.upload(`employer/${employerId}/enrollment/upload/${actionItemId}`, formData);

        if(result && result.parseErrors && result.parseErrors.length > 0){        
            await this.showValidationResultModal(result.parseErrors, employerId, 'parse');
            return false;
        }else {
            return true;
        }          
    }

    async updateParticipants(selectedFile, employerId, successMessage)
    {
        if(!selectedFile) return;

        let formData = new FormData();
        formData.append('file', selectedFile);

        return await this.processParticipantUpdates(employerId, formData, successMessage, false);
    }

    async processParticipantUpdates (employerId, formData, successMessage, overrideWarnings) {
        var result = await romeApi.upload(`employer/${employerId}/enrollment/upload/participant/update?overrideWarnings=${overrideWarnings}`, formData);

        return await this.handleUploadSpreadsheetResults(result, employerId, successMessage, false, async () => await this.processParticipantUpdates(employerId, formData, successMessage, true));
    }

    async midyearEnrollments(selectedFile, employerId, startDate, endDate, successMessage){
        if(!selectedFile) return;

        let formData = new FormData();
        formData.append('file', selectedFile);

        return await this.processMidyearEnrollments(formData, employerId, startDate, endDate, successMessage, false);
    }

    async processMidyearEnrollments(formData, employerId, startDate, endDate, successMessage, overrideWarnings) {
        var result = await romeApi.upload(`employer/${employerId}/enrollment/upload/midyear?startDate=${startDate}&endDate=${endDate}&overrideWarnings=${overrideWarnings}`, formData);

        return await this.handleUploadSpreadsheetResults(result, employerId, successMessage, false, async () => await this.processMidyearEnrollments(formData, employerId, startDate, endDate, successMessage, true));
    }

    async iCubaVestedUpdates(selectedFile, employerId, startDate, endDate, successMessage){
        if(!selectedFile) return;

        let formData = new FormData();
        formData.append('file', selectedFile);

        return await this.processIcubaVestedUpdates(formData, employerId, startDate, endDate, successMessage, false);
    }

    async processIcubaVestedUpdates(formData, employerId, startDate, endDate, successMessage, overrideWarnings) {
        var result = await romeApi.upload(`employer/${employerId}/enrollment/upload/vested?startDate=${startDate}&endDate=${endDate}&overrideWarnings=${overrideWarnings}`, formData);

        return await this.handleUploadSpreadsheetResults(result, employerId, successMessage, false, async () => await this.processIcubaVestedUpdates(formData, employerId, startDate, endDate, successMessage, true)); 
    }

    async bypass(actionItem){
        var confirmed = await modalService.confirm("This action item will be Bypassed. Are you sure?");
        if(confirmed){
            await this.$store.dispatch("actionItems/changeStatus", { actionItem, newStatus: "completed", onComplete: actionItem.onComplete, overrideValidation: true });
        }
    }
    async showValidationResultModal(errors, employerId, validationType) {
        return await modalService.show("enrollmentValidationErrors", EnrollmentValidationErrors, { 
            lines: errors,
            title: "Enrollment Spreadsheet Validation Result",
            errorStyle: true,
            employerId: employerId,
            validationType: validationType,
        });
    }

    async logWarningsOverride(employerId, warnings){
        var logWarnings = []
        warnings.forEach((warning) => {
            logWarnings.push(warning);
        });

        var dto = {warnings: logWarnings};
    
        await romeApi.post(`employer/${employerId}/warnings/override`, dto);
    } 
    
    async logWarningsOverrideForActionItem(employerId, actionItemId, warnings) {
       
        var logWarnings = []
        warnings.forEach((warning) => {
            logWarnings.push(warning);
        });

        var dto = {warnings: logWarnings};

        await romeApi.post(`employer/${employerId}/warnings/override/${actionItemId}`, dto);
    }

    async handleUploadSpreadsheetResults(result, employerId, successMessage, overrideWarnings, overrideFunc) {
        var hasWarnings = result && result.warnings && result.warnings.length > 0;
        var hasErrors = result && result.validationErrors && result.validationErrors.length > 0;

        if (hasWarnings && hasErrors) {  
            let errors = result.warnings.concat(result.validationErrors);
            await this.showValidationResultModal(errors, employerId, 'error');
            return false;
        } else if (hasErrors) {
           await this.showValidationResultModal(result.validationErrors, employerId, 'error');
            return false;
        } else if (hasWarnings && overrideWarnings == false){
            var overrideRequested = await this.showValidationResultModal(result.warnings, employerId, 'warning');
            if(overrideRequested && overrideRequested == true) {
                await this.logWarningsOverride(employerId, result.warnings);
                return await overrideFunc();
            }
        } else {
            await modalService.info(successMessage);
            return true;
        }      
    }

    async validateActionItem( employerId, actionItemId) {
        
        let result = await romeApi.post(`/actionitem/v-2/${actionItemId}/validate`);
        
        var hasWarnings = result && result.warnings && result.warnings.length > 0;
        var hasErrors = result && result.errors && result.errors.length > 0;

        if (hasWarnings && hasErrors) {
            let errors = result.warnings.concat(result.errors);
            await this.showValidationResultModal(errors, employerId, 'error');
        } else if (hasErrors) {
            await this.showValidationResultModal(result.errors, employerId, 'error');
        } else if (hasWarnings){
            
            var overrideRequested = await this.showValidationResultModal(result.warnings, employerId, 'warning');
            
            if (overrideRequested && overrideRequested == true){     
                await this.logWarningsOverrideForActionItem(employerId, actionItemId, result.warnings);
                await this.completeItem(actionItemId, employerId)
            }
        } else {
            await this.completeItem(actionItemId, employerId);
        }
    }

    async completeItem(actionItemId, employerId){
        let validationResult = await romeApi.post(`/actionitem/v-2/${actionItemId}/validate`);

        if(!validationResult.ok){
            await this.showValidationResultModal(validationResult.errors, employerId, 'error', null);
            
        } else {
            await romeApi.post(`actionitem/v-2/${actionItemId}/complete`);
            await this.$store.dispatch("actionItems/refresh");
        }
    }
}

const uploadEnrollmentsService = new UploadEnrollmentsService();

export { uploadEnrollmentsService };



// WEBPACK FOOTER //
// ./src/action-items/types/upload-enrollments-service.js